import Dropdown from "../../form_components/Dropdown";
import { GraphQlWrapper } from "../../utilities/components";
import BaseDialog from "./BaseDialog";

export default class CustomQueryDialog extends BaseDialog {
    _isInitialized = false;

    /**
     * Editor dialog for editing GraphQL query / mutation, inside data access node property panel
     * @module CustomQueryDialog
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.addHandle = this.handleAdd.bind(this);
        this.onEditorContextChange = this.onEditorContextChange.bind(this);
        this.schema = this.props.context.getConfig("schema");
    }

    /**
     * Save to context
     * @param event
     */
    handleAdd() {
        if (this.queryEditor && this.variableEditor&&!this.props.context.isCommonModule) {
            this.props.context.setConfig("script", this.queryEditor.getValue());
            this.props.context.setConfig("variable", this.variableEditor.getValue());
            this.props.context.setConfig("schema", this.schema);
            window.apm.postEventToCurrentView({
                target: "request-refresh",
                event: {id: this.props.context.getID(), type: "node"}
            });
            w2popup.close();
        }
        else  w2popup.close();
    }

    /**
     * Set config proxy
     * @param {string} key
     * @param {string} value
     */
    setConfig(key, value) {
        this.schema = value;
        this.forceUpdate();
    }
    
    componentDidMount() {
        super.componentDidMount();
        document.addEventListener("ev-dialog-add", this.addHandle);
        this._updateContextValues();
    }

    componentDidUpdate() {
        this._updateContextValues();
    }

    /**
     * Called when the GraphQL context changes.
     *
     * EditorContextType
     */
    onEditorContextChange(context) {
        const {
            queryEditor,
            variableEditor
        } = context ?? {};
        this.queryEditor = queryEditor;
        this.variableEditor = variableEditor;
        if (
            !this._isInitialized
            && queryEditor
            && variableEditor
        ) {
            this._isInitialized = true;
            this._updateContextValues();
        }
    }

    _updateContextValues() {
        const queryValue = this.props.context.getConfig("script");
        if (
            this.queryEditor
            && this.queryEditor.getValue() !== queryValue
        ) {
            this.queryEditor.setValue(queryValue ?? '');
        }
        const variableValue = this.props.context.getConfig("variable");
        if (
            this.variableEditor
            && this.variableEditor.getValue() !== variableValue
        ) {
            this.variableEditor.setValue(variableValue ?? '')
        }
        this.getDomSelf().find(".CodeMirror-gutters").css("left", 0);
    }

    unregister(){
        document.removeEventListener("ev-dialog-add", this.addHandle);
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        // Get current schema selection
        let selectedIndex = -1;
        let selectedSchema = null;
        const schemas = window.apm.knowledgeBase.getSchemas();
        const options = schemas.map((schema, index) => {
            const option = {
                name: schema.name,
                value: schema.id
            };

            if (schema.id === this.schema) {
                selectedIndex = index;
                selectedSchema = schema;
            }

            return option;
        });

        return (
            <div className="container-fluid">
                <div className="script-header" style={{fontWeight: "normal", display: "block"}}>
                    <div style={{width: "100%"}}>
                        <Dropdown
                            context={this}
                            label={window.l.popup.use_schema}
                            optionName={window.l.popup.use_schema}
                            options={options}
                            readOnly={this.props.context.isCommonModule}
                            selection={selectedIndex}
                            valKey={"schema"}
                        />
                    </div>
                </div>
                <div className="script-wrapper">
                    <div style={{
                        flexFlow: "column",
                        display: "flex",
                        flex: "1 1 auto",
                    }}>
                        {(!selectedSchema) ? null : (
                            <GraphQlWrapper
                                onContextChange={this.onEditorContextChange}
                                readOnly={this.props.context.isCommonModule}
                                schema={(selectedSchema.type === 'SCHEMA') ? selectedSchema.schema : null}
                                url={selectedSchema.value}
                            />
                        )}
                    </div>
                </div>
                <div className="script-footer">
                </div>
            </div>
        );
    }
}
